var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFE556"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 47.5C46.5 45.4067 46.5 44.36 46.2416 43.5083C45.6599 41.5907 44.1593 40.0901 42.2417 39.5084C41.39 39.25 40.3433 39.25 38.25 39.25H30.75C28.6567 39.25 27.61 39.25 26.7583 39.5084C24.8407 40.0901 23.3401 41.5907 22.7584 43.5083C22.5 44.36 22.5 45.4067 22.5 47.5M41.25 27.25C41.25 30.9779 38.2279 34 34.5 34C30.7721 34 27.75 30.9779 27.75 27.25C27.75 23.5221 30.7721 20.5 34.5 20.5C38.2279 20.5 41.25 23.5221 41.25 27.25Z",
    stroke: "#303539",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal_icon.ca48ac48c770ede98e7360b77588f3f1.svg";
export { ForwardRef as ReactComponent };